export function guardPublishClick(
  event: { preventDefault: () => void },
  isLimitReached: boolean,
  onBlocked: () => void
): boolean {
  if (!isLimitReached) return false;
  event.preventDefault();
  onBlocked();
  return true;
}
